import React from 'react';
import PropTypes from 'prop-types';
import APLabelWithText from '../common/APLabelWithText';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './UserBalanceComponent.css';
var bemClasses = getBEMClasses(['user-balance']);
var UserBalanceComponent = function UserBalanceComponent(props, context) {
  return React.createElement('div', null, React.createElement('div', {
    className: bemClasses(null, 'with-small-padding')
  }, React.createElement(APLabelWithText, {
    label: props.position1.ProductSymbol + ' ' + context.t('Balance') + ':',
    text: props.position1.Amount,
    customClass: bemClasses()
  })), React.createElement(APLabelWithText, {
    label: props.position2.ProductSymbol + ' ' + context.t('Balance') + ':',
    text: props.position2.Amount,
    customClass: bemClasses()
  }));
};
UserBalanceComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default UserBalanceComponent;